import React, {createContext} from 'react';

const MsgContext = createContext({});

export default MsgContext;
